import {useProductService} from '@/composables/product_service'
import {getMappedProduct} from '~/assets/js/utils/product_attributes_mapping'
import {useUserStore} from '@/store/user'
import {PROPERTY_SCOPE_NAMES} from '~/assets/js/constants'
import type {Ref} from 'vue'

export const useReloadProduct = (productRef: Ref<any>, locale: Ref<string>, globalization: any) => {
  const reloadProductsInProgress = ref(false)
  const productService = useProductService()
  const userStore = useUserStore()

  async function reloadProduct(plantCode?: string | null) {
    reloadProductsInProgress.value = true
    if (!productRef.value) {
      reloadProductsInProgress.value = false
      return
    }
    try {
      const updatedProduct = await productService.getProductBySkuNew(
        productRef.value.sku,
        globalization.getRegion(),
        locale.value,
        userStore.showInchValues,
        plantCode as any,
        PROPERTY_SCOPE_NAMES.PRODUCT_PAGE as any
      )
      if (updatedProduct) {
        productRef.value = getMappedProduct(updatedProduct)
      }
    } finally {
      reloadProductsInProgress.value = false
    }
  }

  return {
    reloadProductsInProgress,
    reloadProduct
  }
}
